import cn from 'classnames';
import { useAsyncHandler } from '@@/common/hooks/use-async-handler.hook';
import { NavLink } from '@lib/routing-engine';
import { UiButton } from '@@/ui/components/ui-button';
import { IconProps } from '@consta/uikit/Icon';
import { CogIcon } from '@@/common/icons/cogs.icons';

import { LogoImage } from '@@/common/images';
import styles from './styles.module.sass';

export function SideNav(props: ISideNavProps) {
  const { items, onLogout } = props;

  const { isLoading: isLogouting, handler: onLogoutHandler } = useAsyncHandler({
    handler: onLogout,
  });

  return (
    <div className={styles.root}>
      <NavLink className={styles.logo} to="/">
        <img src={LogoImage} />
      </NavLink>

      <nav className={styles.menu}>
        {items.map((item, index) => (
          <NavLink
            key={index}
            className={styles.link}
            title={item.title}
            to={item.link}
          >
            {({ isActive }) => (
              <div
                className={cn([styles.button, { [styles.button_active]: isActive }])}
              >
                {item.icon({ fill: isActive ? '#66B28A' : '#DFE6FA' } as IconProps)}
              </div>
            )}
          </NavLink>
        ))}
      </nav>

      <UiButton
        className={styles.logout}
        label="Выйти"
        view="clear"
        size="xs"
        loading={isLogouting}
        onClick={onLogoutHandler}
      />
      {/*<UiButton*/}
      {/*  className={cn(styles.button, styles.settingsButton)}*/}
      {/*  iconLeft={CogIcon}*/}
      {/*  onlyIcon*/}
      {/*/>*/}
    </div>
  );
}

export interface ISideNavProps {
  items: {
    link: string;
    title: string;
    icon: (props?: IconProps) => React.ReactNode;
    active?: boolean;
    // badge?: number;
  }[];

  onLogout: () => void | Promise<void>;
}
